module.exports = __webpack_public_path__ + "media/images/icons/country_flags/li-336f4357249e397571f50f3523dcb6fa.svg";